import nodo4000 from '../../images/partners/nodo4000/nodo4000.svg'
import rh4000 from '../../images/partners/nodo4000/rh4000.svg'

const Nodo4000 = () => (
    <div className="uk-container-expand" uk-height-viewport="expand: true">
        <div className="uk-container uk-padding-large uk-text-justify">
            {/* <div className="uk-margin">
                <img src={nodo4000} alt="nodo4000_logo" width="192" />
            </div>
            <h2 className="uk-heading-bullet">¿Quiénes somos?</h2>
            <div className="uk-margin">
                <p>Un equipo de profesionales con mas de una década de experiencia en el sector de servicios de consultoría en Tecnología de Información.</p>
                <p> Creemos en el trabajo en equipo; por ello, nos esforzamos día a día en construir relaciones perdurables basadas en el trabajo arduo, la confianza y la honestidad.</p>
                <p>Nuestra integridad y pasión por lo que hacemos nos hace ser un aliado para el desarrollo de nuestros clientes, más que un simple proveedor.</p>
            </div> */}
            <h2 className="uk-heading-bullet">Soluciones</h2>
            <div className="uk-margin">
                <img src={rh4000} alt="rh4000_logo" width="192" />
            </div>
            <div className="uk-margin">
                <p>OPTIMIZA Y MODERNIZA TUS PROCESOS DE NÓMINA Y RECURSOS HUMANOS</p>
                <p>RH4000 es una plataforma integral con un enfoque estratégico que garantiza la automatización de tus procesos y el cumplimiento legal que necesitas.</p>
                <p>Con sus diferentes módulos te ofrece las mejores prácticas de RH y nóminas, con una navegación y uso intuitivo y una constante optimización de procesos.</p>
                <p>Módulos:</p>
                <p>
                    <dl className="uk-description-list uk-margin-left">
                        <dt><span className='uk-text-bold'>&bull; CAPITAL HUMANO</span></dt>
                        <dd>Módulo que facilita la administración de tus colaboradores como lo son <b>Expediente Digital</b>, <b>Control de vacaciones</b>, y MÁS.</dd>

                        <dt><span className='uk-text-bold'>&bull; ADMINISTRACIÓN DE DOCUMENTOS</span></dt>
                        <dd>Administra y controla los contratos y <b>TODOS</b> los documentos de tus colaboradores, mediante plantillas, generación e impresión masiva y notificación de vencimiento.</dd>

                        <dt><span className='uk-text-bold'>&bull; SELECCIÓN Y RECLUTAMIENTO</span></dt>
                        <dd>Todo tu proceso en un solo modulo, publica y promueve tus vacantes, recluta, evalúa y contrata fácilmente a los mejores candidatos.</dd>

                        <dt><span className='uk-text-bold'>&bull; CAPACITACIÓN</span></dt>
                        <dd>Gestiona la capacitación de tus colaboradores, mediante programas, cursos y sesiones que te permitan analizar costos, cumplimiento legal y cobertura de tu planeación anual.</dd>

                        <dt><span className='uk-text-bold'>&bull; ADMINISTRACIÓN DE BENEFICIOS</span></dt>
                        <dd>Ofrece programas de reconocimiento y recompensa, que te permitan desarrollar y motivar a tus colaboradores.</dd>

                        <dt><span className='uk-text-bold'>&bull; ZONA GERENCIAL</span></dt>
                        <dd>Portal para los JEFES, quienes podrán interactuar con nóminas y RH, así como revisar información de su equipo en tiempo REAL.</dd>

                        <dt><span className='uk-text-bold'>&bull; ZONA EMPLEADO</span></dt>
                        <dd>Portal que tus empleados simplemente van a amar, opciones como consulta e impresión de recibos, solicitar vacaciones y permisos, consulta información y varias opciones más.</dd>

                        <dt><span className='uk-text-bold'>&bull; NOMINA</span></dt>
                        <dd>Nómina <b>segura, flexible y configurable</b>. Siempre cumpliendo TODAS las leyes y normas vigentes. Multi periodos, prenómina, deducciones, cargas masivas, reportes y más. AH y no te preocupes por timbres ya los tienes incluidos.</dd>

                        <dt><span className='uk-text-bold'>&bull; CONTROL DE PRESENCIA</span></dt>
                        <dd>Automatiza tus incidencias, gestiona tus jornadas y controla los accesos de empleados. Información en tiempo real y sincronización con pago de nómina.</dd>
                    </dl>
                </p>
            </div>
        </div>
    </div>
);

export default Nodo4000;